module.exports = __webpack_public_path__ + "static/media/streak-video.e116f9de.mp4";